import { PaymentMethod } from '../../interfaces';
import { PAYMENT_METHOD_ID } from '../payment-method-id';

export const PAYCONIQ: PaymentMethod = {
    id: PAYMENT_METHOD_ID.Payconiq,
    name: 'payconiq',
    displayName: 'Payconiq'
};
